<template>
  <div class="coupon-scope" :style="styleObj">
    <div class="usage-title">{{ title }}</div>
    <div class="usage-desc">{{ desc }}</div>
  </div>
</template>

<script>
export default {
  name: 'coupon-scope',
  data() {
    return {
      title: '',
      desc: '',
      show: false,
      position: {},
    };
  },
  computed: {
    styleObj() {
      return {
        left: `${(this.position.x || this.position.left) + 7 + document.documentElement.scrollLeft}px`, // 7是图标宽度的一般
        top: `${(this.position.y || this.position.top) + document.documentElement.scrollTop}px`,
        display: this.show ? 'flex' : 'none',
      };
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/less/variable";
.coupon-scope {
  display: none;
  flex-direction: column;
  align-items: center;
  padding: 20px 20px 15px 20px;
  width: 306px;
  border-radius: 5px;
  background-color: #fff;
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.15);
  position: absolute;
  z-index: 10000;
  transform: translate(-50%, 25px); // 25像素是等于 图标14像素 + 箭头 10像素 + 1像素多一点点
  &::before {
    content: '';
    position: absolute;
    top: -10px;
    left: 50%;
    transform: translate(-10px);
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #fff;
    z-index: 2;
  }
  &::after {
    content: '';
    position: absolute;
    top: -11px;
    left: 50%;
    transform: translate(-11px);
    border-left: 11px solid transparent;
    border-right: 11px solid transparent;
    border-bottom: 11px solid @border;
    z-index: 1;
  }
  .usage-title {
    font-size: 14px;
    color: #333;
  }
  .usage-desc {
    font-size: 14px;
    line-height: 24px !important;
    margin-top: 10px;
    color: #6f6f6f;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/coupon/coupon-scope/coupon-scope.vue